import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Transition } from "@headlessui/react";
import ProcessingBar2 from "../../../../components/ProcessingBar/ProcessingBar2";

const FourthNightMarket = () => {
  const steps = [
    {
      title: "Quick & Easy Ordering.",
      description:
        "Customers scan QR codes or order online right from their phones. No waiting, no long lines — just fast, simple ordering anytime.",
    },
    {
      title: "Turn Visitors into Regulars.",
      description:
        "Automatically reward repeat customers with digital loyalty stamps and special offers. Build a strong fanbase that keeps coming back.",
    },
    {
      title: "Instant Orders to Kitchen.",
      description:
        "Orders go directly to your kitchen printer or display screen the moment they're placed — reducing wait times and minimizing mistakes.",
    },
  ];

  const [currentStep, setCurrentStep] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let count = 0;

    const timer = setInterval(() => {
      count += 1;
      setProgress(count * 10);

      if (count >= 10) {
        setCurrentStep((prev) => (prev + 1) % steps.length);
        count = 0;
        setProgress(0);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleTitleClick = (index) => {
    setCurrentStep(index);
    setProgress(0); // reset progress when user manually selects
  };

  const navigate = useNavigate();
  const [showProcessing, setShowProcessing] = useState(false);
  const [showProcessingCall, setShowProcessingCall] = useState(false);

  const handleregister = () => {
    setShowProcessing(true);
    setTimeout(() => {
      setShowProcessing(false); // (optional: hide after processing)
      navigate("/register");
    }, 2000);
  };

  const handleBookACall = () => {
    setShowProcessingCall(true);
    setTimeout(() => {
      setShowProcessingCall(false);
      navigate("/contact/book-a-call");
    }, 2000);
  };

  return (
    <div className="bg-border py-20 px-4 text-white">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-16">
        {/* Left Image */}
        <div className="md:w-1/2">
          <div className="rounded-3xl overflow-hidden shadow-xl">
            <img
              src="https://images.pexels.com/photos/784633/pexels-photo-784633.jpeg" // replace with your actual image path
              alt="Client Management"
              className="w-full object-cover grayscale"
            />
          </div>
        </div>

        {/* Right Content */}
        <div className="md:w-1/2">
          <h2 className="text-4xl md:text-5xl font-semibold mb-6 text-text">
            Loyalty Program.
            <br />
            Guests who keep coming back.
          </h2>

          <p className="text-md text-textGray mb-8">
            Reward your regulars with automatic stamp cards and personalized
            offers. Build long-term guest loyalty while Lokalai tracks visits
            and rewards in the background — fully automated for your restaurant.
          </p>

          <div className="transition-opacity duration-700 opacity-100">
            <div className="h-[280px]">
              {steps.map((step, index) => (
                <div key={index} className="mb-8">
                  <h3
                    onClick={() => handleTitleClick(index)}
                    className={`cursor-pointer font-semibold text-lg ${
                      index === currentStep ? "text-redlight" : "text-textGray"
                    }`}
                  >
                    {step.title}
                  </h3>

                  <Transition
                    show={index === currentStep}
                    enter="transition-opacity duration-100"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transition-opacity duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="mt-2 text-text text-sm">
                      {step.description}
                    </div>
                  </Transition>
                  {index === currentStep && (
                    <div className="w-full h-[1px] mt-2 bg-border rounded-full overflow-hidden">
                      <div
                        className="h-full bg-redlight transition-all duration-1000 ease-linear"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-row sm:flex-row items-start sm:items-center gap-4">
            <button
              onClick={handleregister}
              className="bg-redlight text-text px-6 py-3 rounded-full font-semibold text-sm transition-transform duration-200 hover:scale-105 w-[200px] h-[45px]"
            >
              {showProcessing ? (
                <div className="flex items-center justify-center w-full h-full">
                  <ProcessingBar2 />
                </div>
              ) : (
                "Start 30-day free"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FourthNightMarket;
